import {InvalidateOptions, useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {apiClient} from '../../../../../utils/api-client';

export function useRecentsQuery(globalVersionId: number) {
    return useQuery({
        queryKey: ['recents', globalVersionId],
        queryFn: async () =>
            apiClient.get<ViewModeDoc[]>({
                path: 'documents-revisions-service/api/user/documents/recent',
                query: {
                    'global-version': globalVersionId
                }
            })
    });
}

export function useRecentsQueryCache() {
    const queryClient = useQueryClient();

    function invalidate() {
        queryClient.invalidateQueries({queryKey: ['recents']}, {
            refetchType: 'inactive'
        } as InvalidateOptions);
    }

    function addDocument(document: ViewModeDoc) {
        queryClient.setQueriesData<ViewModeDoc[] | undefined>(
            {queryKey: ['recents'], exact: false},
            (currentState) => {
                if (!currentState) {
                    return currentState;
                }

                return [
                    document,
                    ...currentState.filter(({accession}) => accession !== document.accession)
                ];
            }
        );
    }

    return {invalidate, addDocument};
}

/** Add a document to Recents */
export function useAddToRecentsMutation() {
    const recentsQueryCache = useRecentsQueryCache();

    return useMutation({
        mutationFn: (document: ViewModeDoc) => {
            return apiClient
                .post({
                    path: `documents-revisions-service/api/user/documents/${document.accession}/recent`
                })
                .then(() => document);
        },
        onSuccess: recentsQueryCache.addDocument
    });
}
